export const itemSectionId = (itemId: string): string => `tripitem-${itemId}`
